export const minAnioCiclo = 1;
export const maxAnioCiclo = 7;
